export const CHALLENGE_OPTIONS = [
    {
        label: "Seulement challenges",
        value: "only",
    },
    {
        label: "Exclure challenges",
        value: "exclude",
    },
];

export const TRADING_STYLE_OPTIONS = [
    {
        label: "Day trading",
        value: "day_trading",
    },
    {
        label: "Scalping",
        value: "scalping",
    },
];
